import React from 'react'
import ErrorBoundary from './ErrorBoundary'

export const Box = ({
  className = 'pa4',
  style,
  children,
  ...props
}) => {
  return (
    <section className={className} style={{ ...style }}>
      <ErrorBoundary>
        {children}
      </ErrorBoundary>
    </section>
  )
}

export default Box
